function stylesheet(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  var suffixToken = token ? ("-" + token) : "";
  return ".title" + shadowSelector + " {font-family: ITCAvantGardePro-Demi, Arial, sans-serif;font-size: 2.5rem;line-height: 48px;text-align: center;color: #032d60;}.description" + shadowSelector + " {font-size: 1.25rem;text-align: center;color: #444444;line-height: 30px;width: 35%;}.illustration" + shadowSelector + " {max-height: 238px;width: auto;}";
  /*LWC compiler v7.1.3*/
}
export default [stylesheet];